module.exports = __webpack_public_path__ + "img/edge_activites_grande_roue.c8a19d6f.svg";